import { useState } from "react";
import MenuBarComponent from "../Components/MenuBarComponent";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { recoverPasswordService } from "../Service/UserService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

function RecoverPassword() {
    const { t } = useTranslation('recover_password');
    const navigate = useNavigate()
    
    const {
        register,
        setValue,
        handleSubmit,
        formState: { errors },
        } = useForm();

    const onSubmit = (e) => {
        const {email} = e
        recoverPasswordService(t('email_title'), t('email_text'), t('email_button_text'), email).then(res=>{
            console.log(res)
            if (res?.user) {
                toast.success(t('recover_valid_message'))
                navigate('/login')
            } else toast.error(t(res))
        }).catch(error=>{
            console.log(error)
            toast.error(t('recover_invalid_message'))
        })
    }

    return (
        <div className="flex flex-column gap-2">
            <MenuBarComponent />
            <div className="flex flex-column gap-4 align-items-center mt-4">
                <div className="text-xl md:text-3xl font-bold">{t('title')}</div>
                <div className="text-lg md:text-xl">{t('sub_title')}</div>
                <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-4'>
                    <InputText className='w-full' {...register('email', {
                        required: t('email_validation_message'),
                    })} />
                    {errors.email && <span className='form-validation-message'>{errors.email.message}</span>}
                    <div className="flex gap-2 justify-content-center">
                        <Button label={t('send')} type="submit" />
                        <Button label={t('cancel')} onClick={()=>navigate('/')} severity="secondary" />
                    </div>
                </form>
            </div>
            
        </div>
    )
}

export default RecoverPassword